import { render } from "./ResultTableItemSk.vue?vue&type=template&id=78742614&scoped=true"
import script from "./ResultTableItemSk.vue?vue&type=script&lang=js"
export * from "./ResultTableItemSk.vue?vue&type=script&lang=js"

import "./ResultTableItemSk.vue?vue&type=style&index=0&id=78742614&scoped=true&lang=css"
import "./ResultTableItemSk.vue?vue&type=style&index=1&id=78742614&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\52\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78742614"]])

export default __exports__